import React from 'react'
import MultiLoginField from 'modules/Forms/Account/Create/subcomponents/LoginField/MultiLoginField'
import OneLoginField from 'modules/Forms/Account/Create/subcomponents/LoginField/OneLoginField'
import PropTypes from 'prop-types'

const LoginField = (props) => {
  const Component = props.multiLogins ? MultiLoginField : OneLoginField

  return <Component {...props} />
}

export default LoginField

LoginField.propTypes = {
  multiLogins: PropTypes.bool,
}
